var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-sheet',{attrs:{"color":"rgba(247, 219, 209, 0.4)"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('v-choose-lesson-body')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }